export const ENDPOINT_WANTED_LIST_FIND_ALL = '/api/wanted-list/list';
export const ENDPOINT_WANTED_LIST_CREATE_ONE = '/api/wanted-list/create';
export const ENDPOINT_WANTED_LIST_UPDATE_ONE = '/api/wanted-list/update';
export const ENDPOINT_WANTED_LIST_DELETE_ONE = '/api/wanted-list/delete';
